/* eslint-disable */

import MediaCollectionAPI from "./data";

const state = {
  editCollection: null
};

// getters
const getters = {};

// actions
const actions = {
  get: (context, key) => {
    context.commit("SET_LOADING", true);
    return MediaCollectionAPI.get(context, key)
      .then(collection => {
        context.commit("SET_EDIT_COLLECTION", collection);
        return collection;
      })
  },
  imageDelete: (context, key) => {
    context.commit("SET_LOADING", true);
    return MediaCollectionAPI.image.delete(context, key)
  }
};

// mutations
const mutations = {
  SET_EDIT_COLLECTION(state, collection) {
    state.editCollection = collection;
  },
};

export default { namespaced: true, state, getters, actions, mutations };
